import svgUrl from "ni:svgr;EjkcJ3ZKimRMTyZ3MiYfBKlxjnWyQl4obfCgQChqPvg";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiChartSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M7 3h2v9H7V3ZM6 7V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2Zm0 1H4v4h2V8Zm4-3v7h2V5h-2Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiChartSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiChartSIcon)";
}